<div class="container-fluid content-wrapper pt-5 mt-5" >
    <div class=" card">
      <div class="card-header">
        <h5 class="card-title">Your Application Status</h5>
      </div>
      <div class="card-body" >
        <div style="height: 100%; box-sizing: border-box;" *ngIf="!noapplication">
          <ag-grid-angular
           #agGrid
            style="width: 100%; height:8rem; font-size:14px!important;"
            class="ag-theme-alpine"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [pagination]="pagination"
            [rowData]="rowData"
            [animateRows]="true"
            [detailRowHeight]="detailRowHeight"
          ></ag-grid-angular>
        </div>
        <div *ngIf="noapplication">
          <div class="alert alert-warning">
            <p><i class="bi bi-hourglass-split"></i><br>No Application is submitted !!</p>
        </div>
        </div>
    </div>
  </div>
    <!-- <div>
      <button (click)="generateapplicationPdfformigration()" class="btn btn-outline-primary btn-sm btnEdit">
          <i  class="bi bi-eye-fill tblbtn"></i>
          </button>
        </div> -->
  </div >
<!----modal-->
<div class="modal fade" id="candidateprofile" data-bs-backdrop="static" tabindex="-1"  aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      
      <div class="modal-body">
                <div class="card border-secondary mb-3">
                      <div class="card-header d-flex">
                        <h5 class="card-title" style="width: 100%;">Application Id: {{applicationid}}
                        </h5>
                        <div class="text-end" style="width: 100%;">
                        <button type="button" class="btn-close text" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                      <div class="card-body"  style="width:100%;overflow:scroll;overflow-x:hidden;overflow-y:scroll;">
                        <div class="form-group">
                          <div class="row mb-1">
                            <div class="col-md-5">
                                 <label class="control-label">Request Status: <span class="text-info">{{request_status}}</span> </label>
                            </div>
                            <div class="col-md-7">
                                 <label class="control-label">Request Status Remark: <span class="text-info">{{request_status_remark}}</span> </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-5">
                                 <label class="control-label">Application Status: <span class="text-info">{{application_status}}</span> </label>
                            </div>
                            <div class="col-md-7">
                                 <label class="control-label">Application Status Remark: <span class="text-info"> {{application_status_remark}} </span></label>
                            </div>
                         </div>

                        </div>
                        <hr>
                        <form method="post" role="form" #form="ngForm" [formGroup]="Requestform"> 
                          
                             <div class="form-group">
                               
                                <div class="row">
                                        <label class="control-label">Full name as shown in the marksheet card:<span class="strip">*</span></label>
                                        <!-- <div class="col-md-2">
                                            <select  aria-label="Default select example" formcontrolname="salutation" class="form-select ng-pristine ng-invalid ng-touched" name="salutation" disabled="disabled">
                                                <option selected="">{{saluation}}</option></select>
                                        </div> -->
                                        <div class="col-md-12">
                                            <input type="text" formcontrolname="stud_name"  name="stud_name" class="form-control" 
                                            [value]="stud_name" placeholder="Full name as shown in the marksheet card"  disabled="disabled">
                                        </div>
                                </div>
                            </div>
                           
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="control-label">Email:<span class="strip">*</span></label>
                                        <div class="">
                                            <input type="text" name="email"  placeholder="Email" class="form-control" [value]="email_address" disabled="disabled">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="control-label"> Mobile:<span class="strip"></span></label>
                                        <div>
                                            <input type="text" name="mobile"  placeholder="Mobile number" class="form-control" [value]="mobile_no" disabled="disabled">  <!--disabled="disabled" -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="">
                                        <label class="control-label">Address:<span class="strip">*</span></label>
                                        <div class="">
                                            <textarea  rows="4" name="StudentPrNo" [value]="address" class="form-control" disabled="disabled">
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-6">
                                            <label class="control-label">Standard:<span class="strip">*</span></label>
                                            <div class="">
                                              <select aria-label="Default select example" class="form-select" disabled="disabled">
                                                  <option selected>{{standard}}</option></select>
                                              </div>
                                    </div>
                                    <div class="col-md-6">
                                      <label class="control-label"> Month and Year of exam:<span class="strip">*</span></label>
                                               <input type="text" [value]="exam_month_year" class="form-control" disabled="disabled">
                  
                                    </div>
                                    </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-6">
                                              <div class="" >
                                                <label class="control-label">School Index:<span class="strip">*</span></label>
                                                <div class="">
                                                  <input type="text" placeholder="" [value]="school_name" class="form-control" disabled="disabled">
                                                </div>
                                               </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="control-label">Seat no of last exam:<span class="strip">*</span></label>
                                                <div class="">
                                                    <input type="text" [value]="seat_no"  placeholder="Seat no of last exam" class="form-control"  disabled="disabled">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                      <!-- <div class="form-group">
                                      <div class="row">
                                           
                                          </div>
                                    </div> -->
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-6">
                                             
                                                <label for="designation" class=" control-label mx-3">Uploaded Photo<span>*</span></label>
                                                <!-- <input type="file" id="designation" class="form-control" disabled="disabled">   -->
                                                <img id="myImg" src="{{photolink}}"  (click)="openmodal('photoModal')" alt="Profile Photo" >
    
                                                <!-- The Modal -->
                                                <div id="photoModal" class="modal1">
                                                  <span class="close1" (click)="closemodal('photoModal')">&times;</span>
                                                  <img class="modal-content1" id="img01">
                                                  <div id="caption">
                                                    <img  src="{{photolink}}">
                                                  </div>
                                                </div>
                                          
                                            </div>
                                            <div class="col-md-6 mt-4" *ngIf="migration">
                                              <label for="inputEmail3" class=" control-label mx-3">Uploaded Marksheet<span>*</span></label>
                                              <!-- <input type="file" id="inputEmail3" class="form-control" disabled="disabled">--  -->
                                                <!--[ngClass]="{ 'is-invalid': submitted && f.startdate_currentDesignation.errors }" />
                                                <div *ngIf="submitted && f.startdate_currentDesignation.errors" class="invalid-feedback">
                                                  <div *ngIf="f.startdate_currentDesignation.errors.required">Please Provide Date of Appointment to the Current Designation</div>
                                                </div>-->
                                                <a  [href]="marksheetlink" target="_blank" class="ml-2 btn btn-success" download>Download</a>
                                         
                                            </div>
                                        </div>    
                                        <!-- <div class="row" *ngIf="duplicatemarksheetpassing">
                                            <div class="col-md-6 mt-4">
                                              <div class="row">
                                               <label for="designation" class=" control-label mx-3 col-">Uploaded Id Proof<span>*</span></label>                                               
                                               <a  [href]="idprroflink" target="_blank" class="ml-2 btn btn-success col-" download>Download</a>
                                             </div>
                                          
                                            </div>
                                            <div class="col-md-6 mt-4">
                                              <label for="inputEmail3" class=" control-label mx-3 col-">Uploaded Recomendation Letter<span>*</span></label>
                                               <a  [href]="schoolrecletterlink" target="_blank" class="ml-2 btn btn-success col-" download>Download</a>
                                         
                                            </div>
                                        </div>     -->
                                        <div class="row" *ngIf="duplicatemarksheetpassing || changerequest">
                                            <div class="col-md-6 mt-4">
                                             
                                                <label for="designation" class=" control-label mx-3 ">Uploaded Id Proof<span>*</span></label>                                               
                                                <a  [href]="idprroflink" target="_blank" class="ml-2 btn btn-success " download>Download</a>
                                          
                                            </div>
                                            <div class="col-md-6 mt-4">
                                              <label for="inputEmail3" class=" control-label mx-3">Uploaded Request Letter<span>*</span></label>
                                               <a  [href]="schoolrecletterlink" target="_blank" class="ml-2 btn btn-success" download>Download</a>
                                         
                                            </div>
                                        </div>    
                                        <div class="row" *ngIf="changerequest">
                                            <div class="col-md-6 mt-4">
                                             
                                                <label for="designation" class=" control-label mx-3">Uploaded Zonal Permission Letter<span>*</span></label>                                               
                                                <a  [href]="zonalletterlink" target="_blank" class="ml-2 btn btn-success" download>Download</a>
                                          
                                            </div>
                                            <div class="col-md-6 mt-4">
                                              <label for="inputEmail3" class=" control-label mx-3">Uploaded Leaving certificate/General register copy <span>*</span></label>
                                               <a  [href]="lcregicopylink" target="_blank" class="ml-2 btn btn-success" download>Download</a>
                                         
                                            </div>
                                        </div>    
                                          
                                    </div>
                        </form>
                        </div>
                </div>
 </div>
 </div>
 </div>
 </div>
<!-- modal end -->
<!----Print modal-->
<div class="modal fade" id="applicationpdf" data-bs-backdrop="static" tabindex="-1"  aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      
      <div class="modal-body">
                <div class="card border-secondary mb-3">
                      <div class="card-header d-flex">
                        <h5 class="card-title" style="width: 100%;">Application Download
                        </h5>
                        <div class="text-end" style="width: 100%;">
                        <button type="button" class="btn-close text" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <div class="card-body text-center"  style="width:100%;overflow:scroll;overflow-x:hidden;overflow-y:scroll;">
                      <div class="row">
                        <div class="col-md-6">
                          <label class="control-label mt-3"><h5>Click here to Download Application and then to Print</h5></label>
                        </div>
                        <div class="col-md-6">
                          <button class="btn btn-primary btn-lg btnEdit" (click)="generateapplicationPdfformigration(studData.payment_status)">Download</button>
                        </div>
                      </div>
                      <div *ngIf="!showMainContent" class="control-label mt-3" style="color: brown;"><h5>Please make payment to download PDF</h5></div>
                    </div>
                </div>
 </div>
 </div>
 </div>
 </div>
<!-- modal end -->
<!----Payment modal-->
<div class="modal fade" id="paymentmodal" data-bs-backdrop="static" tabindex="-1"  aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      
      <div class="modal-body">
                <div class="card border-secondary mb-3">
                      <div class="card-header d-flex">
                        <h5 class="card-title" style="width: 100%;">Payment
                        </h5>
                        <div class="text-end" style="width: 100%;">
                        <button type="button" class="btn-close text" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <div class="card-body "  style="width:100%;overflow:scroll;overflow-x:hidden;overflow-y:scroll;">
                            <div class="text-center my-4">
                                  <span  class="strip ">Note: If Payment is not Successful Due to Technical reason, Please Wait for 48 Hours, and Recheck. </span>
                            </div>
                           <div class="row mb-4">
                                <div class="col-md-4">
                                  <label class="control-label">Previous Transaction Status: </label>
                                </div>
                                <div class="col-md-8 text-start"><label class="control-label"><span class="strip mt-2" >{{paymentstatus}}, {{paymentresponcemsg}}</span></label></div>
                           </div>    
                           <div class="row mb-4">
                              <div class="col-md-4">
                                <label class="control-label">Total Application Fees: </label>
                              </div>
                              <div class="col-md-8 text-start"><label class="control-label"><span class="">{{totalpay}}/-</span></label></div>
                            </div>   
                            <div class="row mb-4" style="text-align: left;">
                              <div class="col-md-4">
                                <label class="control-label">Choose Fees Payment mode :</label>
                              </div>
                              <div class="col-md-4">
                                  <div class="form-check">
                                      <input class="form-check-input" type="radio" name="MOP"  [disabled]="!allowRePay" id="debitmode" value="4"  (change)="getpaymentmode($event.target)"/>
                                      <label class="form-check-label" >
                                        Debit Card
                                      </label><br>
                                      
                                      <input class="form-check-input" type="radio" name="MOP"  [disabled]="!allowRePay"id="creditmode" value="5"  (change)="getpaymentmode($event.target)"/>
                                      <label class="form-check-label" >
                                        Credit Card
                                      </label>
                                  </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" name="MOP"  [disabled]="!allowRePay" id="debitmode" value="6"  (change)="getpaymentmode($event.target)"/>
                                  <label class="form-check-label" >
                                    UPI
                                  </label><br>
                                  
                                  <input class="form-check-input" type="radio" name="MOP"  [disabled]="!allowRePay" id="creditmode" value="3" (change)="getpaymentmode($event.target)"/>
                                  <label class="form-check-label" >
                                    Net Banking
                                  </label>
                              </div>                      
                                     
                              </div>
    
                            </div> 
                           <div class="row mb-4">
                              <div class="col-md-4">
                                <label class="control-label">Pay here:  </label>
                              </div>
                              <div class="col-md-8 text-start"><button  [disabled]="!isChecked" class=" btn btn-primary btnEdit" (click)="getpaymentdone()">Procceed To Pay</button></div>
                            </div>    
                                <!-- <div class="col-md-7 text-start">
                                   <div class="row">
                                        <div class="col-sm-4">
                                             <button  [disabled]="!allowRePay" class=" btn btn-primary btnEdit" (click)="getpaymentdone()">Procceed To Pay</button>
                                        </div>
                                        <div class="col-sm-8" style="height: 5rem; overflow-y:auto;">
                                            <span class="strip mx-3 mt-2" >Your Previous Transaction Status : {{paymentresponcemsg}}</span>                                       
                                       </div>
                                   </div> 
                                </div> -->
                           
                    </div>
                </div>
 </div>
 </div>
 </div>
 </div>
<!-- modal end -->
